import React, { Component } from 'react';
import { Panel, FormGroup, ControlLabel, FormControl, Form, Button, Glyphicon } from 'react-bootstrap';

export class Setup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            authUrl: "",
            apiDataManagerUrl: "",
            apiBusSchedUrl: "",
            apiBusMapUrl: "",
            clientId: ""
        };

        this.loadSetup();
    }

    setVariable = (e, stateVar) => {
        this.setState({
            [stateVar]: e.target.value
        });
    }

    loadSetup = () => {
        fetch('api/Setup/Load')
            .then(response => {
                response.text()
                    .then(data => {
                        this.setState(JSON.parse(data));
                    });
            });
    }

    saveSetup = () => {
        fetch('api/Setup/Save', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state)
        }).then(() => {
            window.location.href = '/';
        });
    }

    render() {
        let { authUrl, apiDataManagerUrl, apiBusSchedUrl, apiBusMapUrl, clientId } = this.state;

        return (
            <div>
                <h1>Instalação da Aplicação</h1>

                <Panel>
                    <Panel.Heading />
                    <Panel.Body>
                        <Form className="form-horizontal">
                            <FormGroup>
                                <ControlLabel className="col-md-2">Endereço de Servidor de Autenticação</ControlLabel>
                                <div className="col-md-10">
                                    <FormControl value={authUrl} onChange={(e) => this.setVariable(e, 'authUrl')} />
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel className="col-md-2">Endereço da API - Gestor de Dados</ControlLabel>
                                <div className="col-md-10">
                                    <FormControl value={apiDataManagerUrl} onChange={(e) => this.setVariable(e, 'apiDataManagerUrl')} />
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel className="col-md-2">Endereço da API - Horários à Paragem</ControlLabel>
                                <div className="col-md-10">
                                    <FormControl value={apiBusSchedUrl} onChange={(e) => this.setVariable(e, 'apiBusSchedUrl')} />
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel className="col-md-2">Endereço da API - Mapas Esquemáticos</ControlLabel>
                                <div className="col-md-10">
                                    <FormControl value={apiBusMapUrl} onChange={(e) => this.setVariable(e, 'apiBusMapUrl')} />
                                </div>
                            </FormGroup>                            
                            <FormGroup>
                                <ControlLabel className="col-md-2">Client ID</ControlLabel>
                                <div className="col-md-10">
                                    <FormControl value={clientId} onChange={(e) => this.setVariable(e, 'clientId')} />
                                </div>
                            </FormGroup>
                        </Form>
                    </Panel.Body>
                    <Panel.Footer>
                        <Form className="form-horizontal">
                            <FormGroup>
                                <div className="col-md-offset-2 col-md-10">
                                    <Button bsStyle="primary" onClick={this.saveSetup}>
                                        <Glyphicon glyph="ok" /> Guardar
                                    </Button>
                                </div>
                            </FormGroup>
                        </Form>
                    </Panel.Footer>
                </Panel>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Setup.js